/**
 * Calendar Script Starts Here
 */
jQuery( document ).ready( function() {
	// Get the current date
	const currentDate = new Date();
	const currentDay = currentDate.getDate();
	const currentMonth = currentDate.getMonth();

	// Event handler for clicking on calendar days
	jQuery( document ).on( 'click focus', '.calendar__days--inner', function() {
		jQuery( '.event__tooltip' ).hide();
		jQuery( this ).find( '.event__tooltip' ).show();
	} );

	// Event handler for closing event tooltips
	jQuery( document ).on( 'click focusout', '.event__tooltip--close', function() {
		jQuery( '.event__tooltip' ).hide( 100 );
	} );
} );

// Define a jQuery plugin called 'EventCalender'
jQuery.fn.EventCalender = function() {
	jQuery( this ).each( function( i, v ) {
		const element = jQuery( this ); //element
		jQuery( this ).find( '.calendar__days--column' ).removeClass( 'ct-first-row' );
		jQuery( this ).find( '.calendar__days--column' ).removeClass( 'ct-second-row' );
		jQuery( this ).find( '.calendar__days--column' ).removeClass( 'ct-third-row' );
		jQuery( this ).find( '.calendar__days--column' ).removeClass( 'ct-forth-row' );
		jQuery( this ).find( '.calendar__days--column' ).removeClass( 'ct-fifth-row' );

		jQuery( this ).find( '.calendar__days--column' ).removeClass( 'ct-first-col' );
		jQuery( this ).find( '.calendar__days--column' ).removeClass( 'ct-second-col' );
		jQuery( this ).find( '.calendar__days--column' ).removeClass( 'ct-third-col' );
		jQuery( this ).find( '.calendar__days--column' ).removeClass( 'ct-forth-col' );
		jQuery( this ).find( '.calendar__days--column' ).removeClass( 'ct-fifth-col' );
		jQuery( this ).find( '.calendar__days--column' ).removeClass( 'ct-sixth-col' );
		jQuery( this ).find( '.calendar__days--column' ).removeClass( 'ct-seventh-col' );

		const col_length = jQuery( this ).find( '.calendar__days--column' ).length;
		const month = jQuery( this ).find( '.calendar__month--title .heading-4' ).text();

		const day = new Date( `01 ${ month }` ).getDay();

		if ( day > 0 ) {
			for ( i = 0; i < day; i++ ) {
				jQuery( this ).find( '.calendar-days-row' ).prepend( '<div class="calendar__days--column ct-hidden-items"><div class="calendar__days--inner"><div class="calendar__date calendar-date"></div></div></div>' );
			}
		}

		jQuery( this ).find( '.calendar__days--column' ).each( function( ii, vv ) {
			var row_class = '';
			var col_class = '';
			if ( ii < 7 ) {
				var row_class = 'ct-first-row';
				var cols = 7;
			} else if ( ii >= 7 && ii < 14 ) {
				var row_class = 'ct-second-row';
				var cols = 7;
			} else if ( ii >= 14 && ii < 21 ) {
				var row_class = 'ct-third-row';
				var cols = 7;
			} else if ( ii >= 21 && ii < 28 ) {
				var row_class = 'ct-forth-row';
				var cols = 7;
			} else if ( ii >= 28 && ii < 31 ) {
				var row_class = 'ct-firth-row';
				var cols = col_length - 28;
			} else if ( ii >= 31 ) {
				var row_class = 'ct-firth-row';
				var cols = col_length - 28;
			}
			const arr_col0 = [ 1, 8, 15, 22, 29 ];
			const arr_col1 = [ 2, 9, 16, 23, 30 ];
			const arr_col2 = [ 3, 10, 17, 24, 31 ];
			const arr_col3 = [ 4, 11, 18, 25, 32 ];
			const arr_col4 = [ 5, 12, 19, 26, 33 ];
			const arr_col5 = [ 6, 13, 20, 27, 34 ];
			const arr_col6 = [ 7, 14, 21, 28, 35 ];
			// console.log(parseInt(ii) + 1);
			// console.log(jQuery.inArray(parseInt(ii) + 1, arr_col0));
			let col_number = 0;
			if ( jQuery.inArray( parseInt( ii ) + 1, arr_col0 ) !== -1 ) {
				var col_class = 'ct-first-col';
				col_number = 1;
			} else if ( jQuery.inArray( parseInt( ii ) + 1, arr_col1 ) !== -1 ) {
				var col_class = 'ct-second-col';
				col_number = 2;
			} else if ( jQuery.inArray( parseInt( ii ) + 1, arr_col2 ) !== -1 ) {
				var col_class = 'ct-third-col';
				col_number = 3;
			} else if ( jQuery.inArray( parseInt( ii ) + 1, arr_col3 ) !== -1 ) {
				var col_class = 'ct-forth-col';
				col_number = 4;
			} else if ( jQuery.inArray( parseInt( ii ) + 1, arr_col4 ) !== -1 ) {
				var col_class = 'ct-fifth-col';
				col_number = 5;
			} else if ( jQuery.inArray( parseInt( ii ) + 1, arr_col5 ) !== -1 ) {
				var col_class = 'ct-sixth-col';
				col_number = 6;
			} else if ( jQuery.inArray( parseInt( ii ) + 1, arr_col6 ) !== -1 ) {
				var col_class = 'ct-seventh-col';
				col_number = 7;
			}
			// console.log(col_class);
			jQuery( this ).find( '.calendar-event' ).attr( 'data-position', col_number );
			jQuery( this ).find( '.calendar-event' ).attr( 'data-cols', cols );
			jQuery( this ).find( '.calendar-event' ).addClass( col_class + '-item' );

			// jQuery(this).find('.calendar-event').each(function () {

			// })
			jQuery( this ).addClass( row_class );
			jQuery( this ).addClass( col_class );
		} );

		element.find( '.calendar-event' ).each( function() {
			const boxWidth = parseInt( element.find( '.calendar__days--column' ).width() );
			const totalLength = parseInt( jQuery( this ).attr( 'data-length' ) );
			const currentPosition = parseInt( jQuery( this ).attr( 'data-current-length' ) );
			const position = parseInt( jQuery( this ).attr( 'data-position' ) );
			const dayNumber = parseInt( jQuery( this ).parent().text( ) );
			if ( totalLength > 7 ) {
				if ( parseInt( currentPosition ) === 1 ) {
					const width = ( 7.2 - currentPosition ) * boxWidth;
					jQuery( this ).css( 'width', width );
					jQuery( this ).css( 'z-index', 4 );
				} else if ( currentPosition % 7 === 0 && position === 1 && currentPosition >= 7 && dayNumber > 25 ) {
					const width = boxWidth * ( 31 - dayNumber );
					jQuery( this ).css( 'width', width );
					jQuery( this ).css( 'z-index', 4 );
				} else if ( currentPosition % 7 === 0 && position === 1 && currentPosition >= 7 ) {
					const width = boxWidth * 7;
					jQuery( this ).css( 'width', width );
					jQuery( this ).css( 'z-index', 4 );
				} else if ( position === 7 && jQuery( this ).hasClass( 'ct-first-day-in-month' ) ) {
					const width = boxWidth - 18;
					jQuery( this ).css( 'width', width );
					jQuery( this ).css( 'z-index', 4 );
				} else if ( jQuery( this ).hasClass( 'ct-first-day-in-month' ) ) {
					const width = boxWidth * ( 7 - position );
					jQuery( this ).css( 'width', width );
					jQuery( this ).css( 'z-index', 4 );
				}
			} else {
				const width = ( totalLength * boxWidth ) - 18;
				if ( currentPosition === 1 ) {
					jQuery( this ).css( 'width', width );
					jQuery( this ).css( 'z-index', 4 );
				}
			}
		} );

		return element;
	} );
};
